import { render, staticRenderFns } from "./articleHot.vue?vue&type=template&id=d6c534ec"
import script from "./articleHot.vue?vue&type=script&lang=js"
export * from "./articleHot.vue?vue&type=script&lang=js"
import style0 from "./articleHot.vue?vue&type=style&index=0&id=d6c534ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports